import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ErrorService } from '@shared/services/error.service';

export const UNDEFINED_PARAMS_INTERCEPTOR_ERROR_MSG = 'undefined or null path found';

@Injectable()
export class UndefinedUrlInterceptor implements HttpInterceptor {
  constructor(private errorService: ErrorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isPathVariableInValid(req.url) || this.isQueryParameterInValid(req.url)) {
      this.errorService.redirect();
      return throwError(() => new ErrorEvent('client error', <ErrorEventInit>{ message: UNDEFINED_PARAMS_INTERCEPTOR_ERROR_MSG }));
    }
    return next.handle(req);
  }

  isQueryParameterInValid(url: string): boolean {
    try {
      // in URL constructor, non server request will throw error like assets/app_config.json
      const queryParamsUrl: string = new URL(url).search;
      const queryParams: string[] = queryParamsUrl.split('&').map((fullParam) => fullParam.split('=')[1]);
      return queryParams.some((param) => param === 'undefined' || param === 'null');
    } catch (err) {
      return false;
    }
  }

  isPathVariableInValid(url: string): boolean {
    try {
      // non server request will throw error like assets/app_config.json
      const webApiUrl: URL = new URL(url);
      const pathNameList: string[] = webApiUrl.pathname.split('/');
      return pathNameList.some((path) => path === 'undefined' || path === 'null');
    } catch (err) {
      return false;
    }
  }
}
